import { render, staticRenderFns } from "./MBPDepartments.vue?vue&type=template&id=0f2e53a5"
import script from "./MBPDepartments.vue?vue&type=script&lang=js"
export * from "./MBPDepartments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports